const initImageTextIconsPdfListWidget = () => {
    const imageTextIconsPdfListWidgetList = document.querySelectorAll("[data-image-text-icons-pdf-list-widget]");
    if (imageTextIconsPdfListWidgetList && imageTextIconsPdfListWidgetList.length > 0) {
        imageTextIconsPdfListWidgetList.forEach((imageTextIconsPdfListWidget) => {
            const pdfModalCtaList = imageTextIconsPdfListWidget.querySelectorAll("[data-pdf-modal]");
            if (pdfModalCtaList && pdfModalCtaList.length > 0) {
                pdfModalCtaList.forEach((pdfModalCta) => {
                    const modalDownloadList = imageTextIconsPdfListWidget.querySelectorAll("[data-modal-download]");
                    const closeIconList = document.querySelectorAll("[data-close-icon-svg]");
                    pdfModalCta.addEventListener("click", () => {
                        for (let i = 0; i < modalDownloadList.length; i++) {
                            if (pdfModalCta.getAttribute("data-pdf-modal") === modalDownloadList[i].getAttribute("data-modal-download")) {
                                modalDownloadList[i].classList.add("active");
                                document.body.style.overflowY = "hidden";
                            }
                        }
                    });
                    closeIconList.forEach((closeIcon) => {
                        closeIcon.addEventListener("click", () => {
                            for (let i = 0; i < modalDownloadList.length; i++) {
                                if (closeIcon.getAttribute("data-close-icon-svg") === modalDownloadList[i].getAttribute("data-modal-download")) {
                                    modalDownloadList[i].classList.remove("active");
                                    document.body.style.overflowY = "auto";
                                }
                            }
                        });
                    });
                });
            }
        });
    }
};
